import React from 'react'
import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'
import { ConfirmDialog } from 'components/ConfirmDialog'

export function LinXmartDialog({
    show,
    pendingSubmit,
    onClose,
    submitPHNSettings,
    title,
    body,
}) {
    const { resetForm } = useFormikContext()

    if (!show) return null

    const handleConfirm = async () => {
        onClose()
        if (pendingSubmit) {
            await submitPHNSettings(
                pendingSubmit.values,
                pendingSubmit.helpers
            )
        }
    }

    const handleHide = () => {
        onClose()
        resetForm()
    }

    return (
        <ConfirmDialog
            title={title}
            body={body}
            onconfirm={handleConfirm}
            onhide={handleHide}
        />
    )
}

LinXmartDialog.propTypes = {
    show: PropTypes.bool.isRequired,
    pendingSubmit: PropTypes.shape({
        values: PropTypes.object.isRequired,
        helpers: PropTypes.object.isRequired,
    }),
    onClose: PropTypes.func.isRequired,
    submitPHNSettings: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
}

LinXmartDialog.defaultProps = {
    pendingSubmit: null,
}
